<template>
  <v-card-text class="ma-0 pa-0">
    <v-list-item-subtitle two-line class="mb-0" min-width="250">
      <template v-for="(note, idx) in notifications">
        <v-list-item
          :class="`px-2 notification-item ${note.readTime === null ? 'unread' : ''}`"
          exact
          exact-active-class="v-list-item--hideactive"
          :key="idx"
          @click="notificationRoute(note.id, note.concernType, note.concernId)"
        >
          <v-list-item-avatar color="yellow" class="mr-2">
            <v-icon>{{ notificationIcon(note.type) }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-row align="center" justify="space-between" class="ma-0 pa-0">
              <div class="title">{{ note.subject }}</div>
              <div class="caption">{{ note.sentTime | ago }}</div>
            </v-row>
            <v-list-item-subtitle v-html="note.text"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider :key="`${idx}-div`"></v-divider>
      </template>
    </v-list-item-subtitle>
  </v-card-text>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {NotificationMixin} from '@/components/mixins'
// @group Common
// Provides NotificationList
export default {
  name: 'NotificationList',
  mixins: [NotificationMixin],

  computed: {
    ...mapGetters('currentuser', ['notifications'])
  }
}
</script>

<style>
.v-list-item.notification-item.unread {
  background-color: rgb(254, 252, 224);
}
.v-list-item.notification-item .title {
  font-family: 'Dosis', sans-serif !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.v-list-item.v-list-item-subtitle {
  font-family: 'Open Sans', sans-serif !important;
  font-size: 12px !important;
}
.v-list-item.notification-item .v-list-item__content {
  padding-top: 6px;
  padding-bottom: 6px;
}
.v-list-item.notification-item .v-avatar {
  margin-bottom: 6px !important;
  margin-top: 6px !important;
}
</style>